import React, { Fragment } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import KardexFilters from './KardexFilters'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../../components/SnackBar/Snackbar'

interface KardexPageProps {}

export const KardexPage: React.FC<KardexPageProps> = () => {
  const { isActive, message, openSnackBar, isSuccess } = useSnackbar()
  return (
    <Fragment>
      <StandardPage pageTitle={'Solicitud de Kardex'}>
        <KardexFilters openSnackBar={openSnackBar} />
        {/* <GenericTable<ProcessCreateWorkOrder> data={[]} headersConfig={[]} /> */}
      </StandardPage>
      <SnackBar
        message={message}
        status={isSuccess ? 'success' : 'error'}
        open={isActive}
      />
    </Fragment>
  )
}
